export const unacknowledgedLevelItemResourceType = "unacknowledged_level";

export function getUnacknowledgedLevelsPath(companyId: string) {
  return `/companies/${companyId}/unacknowledged_levels`;
}

export function getAcknowledgeLevelPath(userGroupId: string, levelId: string) {
  return `/user_groups/${userGroupId}/level_progress/${levelId}/acknowledge`;
}
